module.exports = __webpack_public_path__ + "static/img/标准齿轮的计算表.82c0224a.jpg";